module.exports = __webpack_public_path__ + "static/media/fireplace.35c10a2e.webm";